import { Component } from '@angular/core';
import { RouteParams } from '@angular/router-deprecated';
import { ScaleValidateService, LoadingService } from '../services';
import { ScaleValidateModel } from '../models';

@Component({
    selector: 'scalevalidate',
    template: require('./scalevalidate.html'),
    providers: [ScaleValidateService],
    directives: [],
})
export class ScaleValidateComponent {
    institutionId: number;
    doStatusCheckFlag = false;
    scaleValidModel = new ScaleValidateModel();

    constructor(
        protected svc: ScaleValidateService, 
        params: RouteParams,
        protected loadingService: LoadingService
    ) {
        this.institutionId = parseInt(params.get('id'));
        this.doStatusCheck();
    }

    doStatusCheck() {
        this.loadingService.startLoad();

        this.svc.checkStatus(this.institutionId).subscribe(response => {
            Object.assign(this.scaleValidModel, response);
            this.doStatusCheckFlag = true;
            this.loadingService.stopLoad();
        });
    }

    fixScales() {
        this.loadingService.startLoad();
        this.doStatusCheckFlag = false;

        this.svc.fixScales(this.institutionId).subscribe(response => {
            Object.assign(this.scaleValidModel, response);
            this.loadingService.stopLoad();
        });
    }
}


/** WEBPACK FOOTER **
 ** ./app/scalevalidate/ScaleValidateComponent.ts
 **/